import { getApolloClient } from '../lib/getApolloClient';
import { handleGraphQLErrors } from '../util/graphqlError.util';
import type { Query } from '../generated/gql-types';
import { GET_PERMISSIONS_FOR_CURRENT_USER } from './permission.gql';

/** Allowable actions for the signed-in user's role and tenant configuration. */
const getPermissionsForCurrentUser = async (): Promise<string[]> => {
  const { data, errors } = await getApolloClient().query<
    Pick<Query, 'getPermissionsForCurrentUser'>
  >({
    query: GET_PERMISSIONS_FOR_CURRENT_USER,
    fetchPolicy: 'network-only',
  });

  handleGraphQLErrors(errors, 'Unable to load permissions.');

  return (data?.getPermissionsForCurrentUser ?? []).filter(
    (permission): permission is string => Boolean(permission),
  );
};

export const permissionActions = {
  getPermissionsForCurrentUser,
};
